import useAuth from '@/hooks/useAuth';
import getCurrentUserId from '@/utils/user/getCurrentUserId';

/**
 * The user id every free-pass query is keyed by, re-read on each auth change.
 * Empty string means logged out.
 *
 * `getCurrentUserId()` is a plain state read, so alone it goes stale — nothing
 * re-renders when a signup lands. Pairing it with `useAuth` (which subscribes)
 * is what swaps the guest cache key for the real one, pulling server truth in
 * with no stale day-1 frame. Forcing `''` while unauthorized also stops a
 * logout leaving the previous user's id on a guest's queries.
 */
const useFreePassUserId = (): string => {
  const { isAuthorized } = useAuth();

  return isAuthorized ? getCurrentUserId() : '';
};

export default useFreePassUserId;
